import type { ChapterItem } from '@app/_proto/Protos/chapters';
import type { NovelItem } from '@app/_proto/Protos/novels';
import { ReactComponent as Lock } from '@app/assets/lock.svg';
import useChapterLockStatus from '@app/domains/common/hooks/useChapterLockStatus';
import HeroTextPlaceholder from '@app/domains/novel/components/HeroTextPlaceholder';
import { BASE_SKELETON_PROPS } from '@app/domains/novel/constants';
import clsx from 'clsx';
import { useMemo } from 'react';

type Props = {
    novel: NovelItem;
    chapter: ChapterItem | undefined;
};

export default function ChapterContentTitle({ novel, chapter }: Props) {
    const { isChapterLocked } = useChapterLockStatus({ novel, chapter });

    const chapterContentTitle = useMemo(() => {
        return `${chapter?.name ?? ''}${chapter?.isTeaser ? ' (Teaser)' : ''}`;
    }, [chapter]);

    return (
        <h4
            data-testid="heading"
            className={clsx('font-set-b18 flex items-start !font-sans sm:font-set-b26', {
                'text-spoiler': chapter?.spoilerTitle,
            })}
        >
            <HeroTextPlaceholder
                data-testid="skeleton"
                className="h-[32px] w-[325px]"
                item={chapter}
                skeletonProps={BASE_SKELETON_PROPS}
            >
                {isChapterLocked && (
                    <span className="pt-[3px]">
                        <Lock
                            data-testid="lock-icon"
                            className="mr-[4px] h-[16px] w-[16px] flex-shrink-0 sm:h-[24px] sm:w-[24px]"
                        />
                    </span>
                )}
                <span data-testid="title">{chapterContentTitle}</span>
            </HeroTextPlaceholder>
        </h4>
    );
}
